import React from "react";
import { useNavigate } from "react-router-dom";
import { FaLock } from "react-icons/fa";

const Unauthorized = () => {
  const navigate = useNavigate();

  // Function to handle the "Go Back" button
  const handleGoBack = () => {
    navigate(-1); // Navigates to the previous page in history
  };

  return (
    // Outer container: Light gray background
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      {/* Central Card: White, rounded box */}
      <div className="bg-white p-10 sm:p-12 rounded-lg shadow-2xl max-w-lg w-full text-center">
        {/* Lock icon and 403 status */}
        <div className="flex flex-col items-center justify-center">
          <div className="relative flex items-center justify-center mb-6">
            {/* Lock icon - Large, Red */}
            <div className="relative">
              <FaLock className="text-red-600 text-[5rem] relative z-10" />
              {/* Red 'shadow' part */}
              <div className="absolute top-[-10px] right-[-10px] w-12 h-12 bg-red-400 rounded-full opacity-50 blur-sm z-0"></div>
            </div>

            {/* 403 Badge */}
            <div className="bg-red-500 text-white px-3 py-1 ml-[-15px] mt-[-30px] rounded-md text-xl font-bold shadow-md relative z-20">
              403
            </div>
          </div>
        </div>

        {/* Heading */}
        <h1 className="text-3xl font-bold text-gray-800 mt-0 mb-4">
          PERMISSION REQUIRED
        </h1>

        {/* Description */}
        <div className="text-gray-600 space-y-3 text-base leading-relaxed">
          <p>Sorry, you don’t have permission to view this page.</p>
        </div>

        {/* Button - Only one button now, styled in Red */}
        <div className="flex justify-center mt-6">
          <button
            onClick={handleGoBack}
            // Button style changed to Red: bg-red-600 with white text
            className="bg-red-600 text-white hover:bg-red-700 transition px-8 py-3 rounded-md text-lg font-semibold shadow-lg"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
